/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import { compose, pure } from 'recompose';
// import cx from 'classnames';
// import classes from './ErrorComponent.scss';
import { getErrors } from '../../selectors/errors';
import type { StateType, ErrorType } from '../../actions/errors';

type PropsType = {
  errors: Array<ErrorType>,
};

// eslint-disable-next-line react/prefer-stateless-function
export class ErrorComponent extends React.Component<PropsType, *> {
  static defaultProps = {
    errors: [],
  };
  props: PropsType;

  render() {
    const errors: any = this.props.errors.map(
      (e: ErrorType) => <div key={e.data.timestamp}>{e.data.message}</div>,
    );
    return (
      <div>
        {errors}
      </div>
    );
  }
}

function mapStateToProps(state: StateType) {
  return {
    errors: getErrors(state),
  };
}

const enhancer = compose(
  connect(mapStateToProps),
  pure,
);

export default enhancer(ErrorComponent);



// WEBPACK FOOTER //
// ./src/components/ErrorComponent/ErrorComponent.js